<template>
  <v-breadcrumbs class="pl-0 pt-0" large>
    <v-icon>mdi-chevron-right</v-icon>
    <v-breadcrumbs-item :activeClass="pageIdentifier ? '' : 'v-breadcrumbs__item--disabled'" :link="true" :to="basePath">{{$route.meta.bcText}}</v-breadcrumbs-item>
    <v-breadcrumbs-item v-if="pageIdentifier"><v-icon>mdi-chevron-right</v-icon></v-breadcrumbs-item>
    <v-breadcrumbs-item :disabled="true" v-if="pageIdentifier">{{pageIdentifier}}</v-breadcrumbs-item>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  data () {
    return {
      pageIdentifier: null
    }
  },
  computed: {
    basePath () {
      return `/${this.$route.path.split('/')[1]}`
    }
  },
  mounted () {
    this.$root.$on('breadcrumbs', (item) => {
      this.pageIdentifier = item
    })
  }
}
</script>

<style scoped>
.v-breadcrumbs {
  margin-top:10px
}
</style>
